import { render, staticRenderFns } from "./sgh-popup-newsletter.vue?vue&type=template&id=38920bde&scoped=true"
import script from "./sgh-popup-newsletter.vue?vue&type=script&lang=js"
export * from "./sgh-popup-newsletter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38920bde",
  null
  
)

export default component.exports